module.exports = __webpack_public_path__ + "img/153.7c6495be.jpg";